import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

export const CtaBand = () => (
  <section className="py-16 sm:py-20" data-testid="cta-band">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col items-center gap-5 rounded-[2rem] bg-petrol px-8 py-12 text-center text-cream sm:px-14">
          <h3 className="font-serif text-3xl font-semibold tracking-tight sm:text-4xl">
            Mietitkö jo omaa iltaa?
          </h3>
          <p className="max-w-lg text-base leading-relaxed text-cream/80">
            Lomakkeen täyttäminen vie minuutin – ja vastaan sinulle
            mahdollisimman pian.
          </p>
          <button
            data-testid="cta-band-button"
            onClick={() => scrollToId("yhteydenotto")}
            className="mt-1 rounded-full bg-cream px-8 py-4 text-base font-semibold text-petrol-night transition-all duration-300 hover:-translate-y-0.5 hover:bg-beige"
          >
            Ota yhteyttä
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
